import { StyledEngineProvider } from "@mui/material";
import { LicenseInfo } from "@mui/x-data-grid-pro";
import * as Sentry from "@sentry/react";
import { App } from "App";
import { createRoot } from "react-dom/client";
import { fetcher } from "services/api.service";
import { SWRConfig } from "swr";
import "./assets/index.css";

const licenseKey = process.env.REACT_APP_MUI_PRO || "";
LicenseInfo.setLicenseKey(licenseKey);

const dsn = process.env.REACT_APP_SENTRY_DSN;
if (dsn) {
  const rate = parseFloat(process.env.REACT_APP_SENTRY_SAMPLE_RATE || "1.0");
  Sentry.init({
    dsn,
    integrations: [Sentry.browserTracingIntegration()],
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: rate,
  });
}
declare module "@mui/material/styles" {
  interface Palette {
    neutral: Palette["primary"];
  }

  interface PaletteOptions {
    neutral?: PaletteOptions["primary"];
  }
}
declare module "@mui/material/Radio" {
  interface RadioPropsColorOverrides {
    neutral: true;
  }
}

createRoot(document.getElementById("root") as HTMLElement).render(
  <StyledEngineProvider injectFirst>
    <SWRConfig value={{ fetcher: fetcher }}>
      <App />
    </SWRConfig>
  </StyledEngineProvider>,
);
